import React from "react";
import logo from "../assets/logo-licom.png";
import ThemeToggle from "./ThemeToggle";

export default function AdminShell({ title, backHref = "/", backLabel = "Kalender", actions, children }) {
  return (
    <div className="page-shell">
      <header className="h-14 px-4 flex items-center gap-3 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
        <img src={logo} alt="" className="w-8 h-8 flex-shrink-0" />
        <a href={backHref} className="btn-ghost text-xs md:text-sm flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
          {backLabel}
        </a>
        <h1 className="text-base md:text-lg font-semibold text-gray-800 dark:text-gray-100 truncate min-w-0">
          {title}
        </h1>
        <div className="ml-auto flex items-center gap-2 flex-shrink-0">
          {actions}
          <ThemeToggle />
        </div>
      </header>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </div>
    </div>
  );
}
